/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCardChallengeRequestBrowserInfo
 */
export interface GetCardChallengeRequestBrowserInfo {
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    acceptHeader: string;
    /**
     * 
     * @type {number}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    screenHeight: number;
    /**
     * 
     * @type {number}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    screenWidth: number;
    /**
     * 
     * @type {number}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    colorDepth: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    javaEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    userAgent: string;
    /**
     * 
     * @type {number}
     * @memberof GetCardChallengeRequestBrowserInfo
     */
    timeZoneOffset: number;
}

/**
 * Check if a given object implements the GetCardChallengeRequestBrowserInfo interface.
 */
export function instanceOfGetCardChallengeRequestBrowserInfo(value: object): value is GetCardChallengeRequestBrowserInfo {
    if (!('acceptHeader' in value) || value['acceptHeader'] === undefined) return false;
    if (!('screenHeight' in value) || value['screenHeight'] === undefined) return false;
    if (!('screenWidth' in value) || value['screenWidth'] === undefined) return false;
    if (!('colorDepth' in value) || value['colorDepth'] === undefined) return false;
    if (!('javaEnabled' in value) || value['javaEnabled'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('userAgent' in value) || value['userAgent'] === undefined) return false;
    if (!('timeZoneOffset' in value) || value['timeZoneOffset'] === undefined) return false;
    return true;
}

export function GetCardChallengeRequestBrowserInfoFromJSON(json: any): GetCardChallengeRequestBrowserInfo {
    return GetCardChallengeRequestBrowserInfoFromJSONTyped(json, false);
}

export function GetCardChallengeRequestBrowserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardChallengeRequestBrowserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptHeader': json['acceptHeader'],
        'screenHeight': json['screenHeight'],
        'screenWidth': json['screenWidth'],
        'colorDepth': json['colorDepth'],
        'javaEnabled': json['javaEnabled'],
        'language': json['language'],
        'userAgent': json['userAgent'],
        'timeZoneOffset': json['timeZoneOffset'],
    };
}

export function GetCardChallengeRequestBrowserInfoToJSON(json: any): GetCardChallengeRequestBrowserInfo {
    return GetCardChallengeRequestBrowserInfoToJSONTyped(json, false);
}

export function GetCardChallengeRequestBrowserInfoToJSONTyped(value?: GetCardChallengeRequestBrowserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptHeader': value['acceptHeader'],
        'screenHeight': value['screenHeight'],
        'screenWidth': value['screenWidth'],
        'colorDepth': value['colorDepth'],
        'javaEnabled': value['javaEnabled'],
        'language': value['language'],
        'userAgent': value['userAgent'],
        'timeZoneOffset': value['timeZoneOffset'],
    };
}

